import { t } from '../../../shared/config/translations'
import { formatDate } from '../../utils/format'
import { escapeHtml } from '../../utils/html'

export interface EditHistoryEntry {
	id: number
	date: string | null
	isNew: boolean
	removed: boolean
}

/** Keeps individual listens distinct, including multiple listens on the same date. */
export function releaseEditHistoryListTemplate(
	entries: EditHistoryEntry[],
): string {
	return [...entries]
		.sort(
			(a, b) => (b.date ?? '').localeCompare(a.date ?? '') || a.id - b.id,
		)
		.map((entry) => {
			const label = entry.date
				? formatDate(entry.date)
				: t('release.unknownDateSummary')
			const action = entry.removed
				? t('release.undoHistoryRemoval')
				: t('dialog.remove')
			return `<li class="edit-history-row${entry.removed ? ' is-removed' : ''}">
				<span class="edit-history-date">${escapeHtml(label)}</span>
				${entry.isNew ? `<span class="edit-history-new">${t('release.newHistoryDate')}</span>` : ''}
				<button type="button" class="btn noFrame small" data-history-entry="${entry.id}" aria-label="${escapeHtml(`${action}: ${label}`)}">${action}</button>
			</li>`
		})
		.join('')
}

export function listenDateErrorTemplate(message: string): string {
	return `<p id="listen-date-error" class="error">${message}</p>`
}

export function releaseTitleTemplate(title: string): string {
	return `${escapeHtml(title)}<span class="hide-icon-header"><svg><use href="#symbols-eye-closed"></use></svg></span>`
}
